// react
import React, { useEffect, useState, useContext } from "react";

// context
import ProductContext from "../../context/ProductContext";

// components
import VisuallyHidden from "../visuallyHidden/VisuallyHidden";

// styles
import "./counter.styles.scss";

interface CounterProps {
  min?: number;
  max?: number;
  onCountChanged?: (count: string) => void;
  onKeyPress?: (e: any) => void;
}

const Counter = ({ min, max, onKeyPress }: CounterProps) => {
  const context: any = useContext(ProductContext);

  const {
    productDispatch,
    productState: { Quantity },
  }: {
    productDispatch: any;
    productState: {
      Quantity: string;
    };
  } = context;

  const [count, setStateCount]: [count: string, setStateCount: any] =
    useState(Quantity);

  const parsedCountInt = parseInt(count);
  const minCheck = (val: number) => (min ? val >= min : true);
  const maxCheck = (val: number) => (max ? val <= max : true);
  const setCountStringHandler = (count: any) => setStateCount(count.toString());

  const increment = () => {
    const updatedCount = parsedCountInt + 1;

    if (maxCheck(updatedCount)) setCountStringHandler(updatedCount);
  };

  const decrement = () => {
    const updatedCount = parsedCountInt - 1;

    if (minCheck(updatedCount)) return setCountStringHandler(updatedCount);
  };

  const numberChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const valueAsString = event.target.value;
    const valueAsInt = parseInt(valueAsString);
    const isIntegerRegex = new RegExp(/^[0-9]+$/);
    const isNotInteger = !isIntegerRegex.test(valueAsString);

    // handle empty string, which is valid
    if ("" === valueAsString) return setStateCount("");

    // if string is not a number
    if (isNotInteger) return;

    // sets to min if they try to go under
    if (min && !minCheck(valueAsInt)) return setCountStringHandler(min);

    // sets to max if they try to go over
    if (max && !maxCheck(valueAsInt)) return setCountStringHandler(max);

    return setStateCount(valueAsString);
  };

  useEffect(() => {
    productDispatch({
      type: "SET_COUNTER_QUANTITY",
      payload: count,
    });
    // eslint-disable-next-line
  }, [count]);

  return (
    <div className="counter">
      <button className="counter-btn counter-btn_decrement" onClick={decrement}>
        <VisuallyHidden>Decrease Quantity</VisuallyHidden>-
      </button>
      <input
        id="quantity"
        className="counter-count"
        value={count}
        onChange={numberChangeInput}
        onKeyPress={onKeyPress}
      />
      <button className="counter-btn counter-btn_increment" onClick={increment}>
        <VisuallyHidden>Increase Quantity</VisuallyHidden>+
      </button>
    </div>
  );
};

export default Counter;
